
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/upsells-dashboard",
      function () {
        return require("private-next-pages/reports/upsells-dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/upsells-dashboard"])
      });
    }
  